/**
 * ServiceAlert API Documentation
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LogLevel = {
    Debug: 'Debug',
    Information: 'Information',
    Warning: 'Warning',
    Error: 'Error',
    Fatal: 'Fatal'
} as const;
export type LogLevel = typeof LogLevel[keyof typeof LogLevel];

